import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useTranslator from './useTranslator';

export const usePageTitle = () => {
  const location = useLocation();
  const { _t } = useTranslator();

  const getPageTitle = () => {
    const suffix = _t("page_title_suffix", "Off The Tree");

    const titles = {
      '/':                           `${_t("page_dashboard", "Dashboard")} | ${suffix}`,
      '/dashboard':                  `${_t("page_dashboard", "Dashboard")} | ${suffix}`,
      '/login':                      `${_t("page_login", "Login")} | ${suffix}`,
      '/create-password':            `${_t("page_create_password", "Create Password")} | ${suffix}`,
      '/reset-password':             `${_t("page_reset_password", "Reset Password")} | ${suffix}`,
      '/forgot-password':            `${_t("page_forgot_password", "Forgot Password")} | ${suffix}`,
      '/manager':                    `${_t("page_managers", "Managers")} | ${suffix}`,
      '/employee':                   `${_t("page_employees", "Employees")} | ${suffix}`,
      '/staff-attendance':           `${_t("page_staff_attendance", "Staff Attendance")} | ${suffix}`,
      '/attendance-report':          `${_t("page_attendance_report", "Attendance Report")} | ${suffix}`,
      '/employee-attendance':        `${_t("page_employee_attendance", "Employee Attendance")} | ${suffix}`,
      '/employee-attendance-report': `${_t("page_employee_attendance_report", "Employee Attendance Report")} | ${suffix}`,
      '/employee-details':           `${_t("page_employee_details", "Employee Details")} | ${suffix}`,
      '/supplier':                   `${_t("page_suppliers", "Suppliers")} | ${suffix}`,
      '/unloading':                  `${_t("page_unloading", "Unloading")} | ${suffix}`,
      '/washing-area':               `${_t("page_washing_area", "Washing Area")} | ${suffix}`,
      '/processing-washing':         `${_t("page_processing_washing", "Processing Washing")} | ${suffix}`,
      '/rework':                     `${_t("page_rework", "Rework")} | ${suffix}`,
      '/refrigeration':              `${_t("page_refrigeration", "Refrigeration")} | ${suffix}`,
      '/packing-washing':            `${_t("page_packing_washing", "Packing Washing")} | ${suffix}`,
      '/green-room':                 `${_t("page_green_room", "Green Room")} | ${suffix}`,
      '/rejection':                  `${_t("page_rejection_log", "Rejection Log")} | ${suffix}`,
      '/receiving-dashboard':        `${_t("page_receiving_dashboard", "Receiving Dashboard")} | ${suffix}`,
      '/ripening-dashboard':         `${_t("page_ripening_dashboard", "Ripening Dashboard")} | ${suffix}`,
      '/processing-dashboard':       `${_t("page_processing_dashboard", "Processing Dashboard")} | ${suffix}`,
      '/processing':                 `${_t("page_processing", "Processing")} | ${suffix}`,
      '/cooking':                    `${_t("page_cooking", "Cooking")} | ${suffix}`,
      '/packing-dashboard':          `${_t("page_packing_dashboard", "Packing Dashboard")} | ${suffix}`,
      '/packing':                    `${_t("page_packing", "Packing")} | ${suffix}`,
      '/bagging':                    `${_t("page_bagging", "Bagging")} | ${suffix}`,
      '/packing-sorting':            `${_t("page_packing_sorting", "Packing Sorting")} | ${suffix}`,
      '/rework-dashboard':           `${_t("page_rework_dashboard", "Rework Dashboard")} | ${suffix}`,
      '/humid':                      `${_t("page_humid", "Humid")} | ${suffix}`,
      '/toasted':                    `${_t("page_toasted", "Toasted")} | ${suffix}`,
      '/rework-refrigeration':       `${_t("page_rework_refrigeration", "Rework Refrigeration")} | ${suffix}`,
      '/cold-storage':               `${_t("page_cold_storage", "Cold Storage")} | ${suffix}`,
      '/ripening-room':              `${_t("page_ripening_room", "Ripening Room")} | ${suffix}`,
      '/sorting':                    `${_t("page_sorting", "Sorting")} | ${suffix}`,
      '/ripening-washing':           `${_t("page_ripening_washing", "Ripening Washing")} | ${suffix}`,
      '/brokerage-dashboard':        `${_t("page_brokerage_dashboard", "Brokerage Dashboard")} | ${suffix}`,
      '/material-entered':           `${_t("page_material_entered", "Material Entered")} | ${suffix}`,
      '/packing-and-sorting':        `${_t("page_packing_and_sorting", "Packing and Sorting")} | ${suffix}`,
      '/brokerage-sorting':          `${_t("page_brokerage_sorting", "Brokerage Sorting")} | ${suffix}`,
      '/brokerage-packing':          `${_t("page_brokerage_packing", "Brokerage Packing")} | ${suffix}`,
      '/brokerage-refrigeration':    `${_t("page_brokerage_refrigeration", "Brokerage Refrigeration")} | ${suffix}`,
      '/refrigeration-area':         `${_t("page_refrigeration_area", "Refrigeration Area")} | ${suffix}`,
      '/bill-creation':              `${_t("page_create_bill", "Create Bill")} | ${suffix}`,
      '/bill-listing':               `${_t("page_bills", "Bills")} | ${suffix}`,
      '/bill-report':                `${_t("page_billing_report", "Billing Report")} | ${suffix}`,
      '/gas-consumtion':             `${_t("page_gas_consumption", "Gas Consumption")} | ${suffix}`,
      '/role-and-permission':        `${_t("page_role_permissions", "Role & Permissions")} | ${suffix}`,
      '/mixing':                     `${_t("page_mixing", "Mixing")} | ${suffix}`,
      '/pasting':                    `${_t("page_pasting", "Pasting")} | ${suffix}`,
      '/rework-packing':             `${_t("page_rework_packing", "Rework Packing")} | ${suffix}`,
      '/turn-2':                     `${_t("page_turn_2", "Turn 2")} | ${suffix}`,
    };

    if (location.pathname.startsWith('/bill-report/')) {
      return `${_t("page_bill_report", "Bill Report")} | ${suffix}`;
    }

    return titles[location.pathname] || suffix;
  };

  useEffect(() => {
    document.title = getPageTitle();
  }, [location.pathname, _t]);
};
